module.exports = __webpack_public_path__ + "static/media/snapscope-4.9340638d.jpg";